import { Field } from 'formik'
import React, { useState } from 'react'
import { BsEyeSlash, BsEye } from 'react-icons/bs'
import IField from '../../../../interfaces/field'
import { theme } from '../../../../styles/theme'
import TplGroup from '../tpl-group'

import {
  Input,
} from './styles'

type IProps = any & IField

const InputPassword = ({
  placeholder = 'Digite aqui',
  required = false,
  name,
  prefixName = '',
  title,
  type,
  ...el
}: IProps): JSX.Element | null => {
  const [isSecret, setIsSecret] = useState(true)

  const handleChange = (event: { target: { value: string } }): void => {
    let { value } = event.target
    if (el.validations?.includes('email')) value = event.target.value.replace(/\s/g, '')

    if (el.setFieldValue) {
      el.setFieldValue(`${prefixName}${name}`, value)
    }
  }

  return (
    <TplGroup
      name={`${prefixName}${name}`}
      title={title}
      prefixName={prefixName}
      required={required}
      {...el}
    >
      <Field
        name={`${prefixName}${name}`}
        required={required}
        value={el.values[name]}
        onChange={(event: any) => handleChange(event)}
      >
        {({ field }: any) => (
          <>
            <Input
              {...el}
              name={name}
              type={isSecret ? type : 'text'}
              placeholder={placeholder || ''}
              {...field}
            />
            <button type="button" onClick={() => setIsSecret((s) => !s)}>
              {
                isSecret
                  ? (<BsEyeSlash size={24} color={theme.colors.gray500} />)
                  : (<BsEye size={24} color={theme.colors.gray500} />)
              }
            </button>
          </>
        )}
      </Field>
    </TplGroup>
  )
}

export default InputPassword
